<template>
  <a>
    <span class="modal-body-text">By submitting, you are agreeing that all the details of this event are accurate.</span><br/>
    <span class="modal-body-text">The event will be sent to the client for their approval.</span><br/><br/>
  </a>
</template>

<script>
export default {
  name: 'suggest-changes-body-modal'
}
</script>

<style lang="less">

</style>




// WEBPACK FOOTER //
// SuggestChanges.vue?a3c24810